import emojiRegex from 'emoji-regex';

export default function restrictEmoji(labelVal) {
  const regex = emojiRegex();
  return !(labelVal && regex.test(labelVal)) || labelVal.length === 0;
}
